/**
 * Tanıtım gönderimi read model (GET /leads/outreach, v0.1.135): per campaign the conditions a send
 * needs and its drafts, and the first wave's mails in Turkish and English (v0.1.140: one wave per campaign
 * that has a mailbox).
 */

import type { OutreachAddressState, OutreachGateState } from '@twin/contracts';

export type {
  OutreachAddressState,
  OutreachAudit,
  OutreachAuditItem,
  OutreachCampaign,
  OutreachCampaignApproveResponse,
  OutreachGate,
  OutreachGateState,
  OutreachMailState,
  OutreachMessageDecisionRequest,
  OutreachMessageDecisionResponse,
  OutreachRefutationResponse,
  OutreachReply,
  OutreachReplyAnswer,
  OutreachView,
  OutreachWave,
  OutreachWaveMail,
} from '@twin/contracts';
export { OUTREACH_AUDIT_CODE_TR, OUTREACH_DRAFT_FLAG_TR, OUTREACH_REPLY_CLASS_TR } from '@twin/contracts';

export const GATE_STATE_LABELS: Readonly<Record<OutreachGateState, string>> = Object.freeze({
  done: 'Tamam',
  waiting: 'Bekliyor',
  failed: 'Sorun var',
});

export const ADDRESS_STATE_LABELS: Readonly<Record<OutreachAddressState, string>> = Object.freeze({
  usable: 'Adres kontrolden geçti',
  waiting: 'Adres kontrol bekliyor',
  blocked: 'Adres kullanılamaz',
});

export const CAMPAIGN_STATUS_LABELS: Readonly<Record<string, string>> = Object.freeze({
  draft: 'Taslak',
  awaiting_approval: 'Onay bekliyor',
  active: 'Etkin',
  paused: 'Durduruldu',
  stopped: 'Kapatıldı',
  completed: 'Bitti',
});

export const AUDIT_STATUS_LABELS: Readonly<Record<string, string>> = Object.freeze({
  planned: 'planlandı',
  running: 'sürüyor',
  passed: 'geçti',
  failed: 'geçmedi',
  cancelled: 'iptal',
});

export const AUDIT_FINDING_LABELS: Readonly<Record<string, string>> = Object.freeze({
  ok: 'Temiz',
  field_error: 'Düzeltilecek hata',
  must_not_deliver: 'Gönderilmemeli',
});

export const REFUTATION_LABELS: Readonly<Record<string, string>> = Object.freeze({
  pending: 'Kararını bekliyor',
  upheld: 'Denetçi haklı dedin; firma dalgadan çıktı',
  overturned: 'Denetçi yanılıyor dedin; firma dalgada',
  not_needed: '',
});

export const MAIL_STATE_LABELS: Readonly<Record<string, string>> = Object.freeze({
  open: '',
  approved: 'Onaylandı · sıraya girecek',
  scheduled: 'Sırada · iş saatinde gidecek',
  sending: 'Gönderiliyor',
  sent: 'Gönderildi',
  failed: 'Gönderilemedi',
  blocked: 'Gönderim kapısı durdurdu',
  rejected: 'Reddettin',
  cancelled: 'İptal',
});

export const PROBE_RESULT_LABELS: Readonly<Record<string, string>> = Object.freeze({
  inbox: 'gelen kutusu',
  promotions: 'Promosyonlar',
  spam: 'spam',
  missing: 'ulaşmadı',
});
